export const BACKGROUND_COLOR = '#000000';
export const MAIN_COLOR = '#FF543D';
export const SECONDARY_COLOR = '#FFFFFF';